import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

export const ProtectedRoute = ({ isAuthed, uid, isLoading, children }) => {
  const [searchParams] = useSearchParams();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Si l'utilisateur n'est pas authentifié mais que des params chiffrés a/b sont présents,
  // on redirige vers / en préservant les params pour déclencher l'authentification via SignInForm
  if (!isAuthed) {
    const paramA = searchParams.get('a');
    const paramB = searchParams.get('b');
    if (paramA && paramB) {
      return <Navigate to={`/?a=${encodeURIComponent(paramA)}&b=${encodeURIComponent(paramB)}`} />;
    }
  }

  // Si l'utilisateur tente de se connecter avec l'ancienne méthode (uid=)
  if (!isAuthed && searchParams.get('uid')) {
    return <Navigate to="/deconnexion?legacy=true" />;
  }

  // Si l'utilisateur n'est pas authentifié, on le redirige vers la page de déconnexion
  if (!isAuthed) {
    return <Navigate to="/deconnexion" />;
  }

  // Si tout est OK, on rend les enfants (composants imbriqués dans cette route protégée)
  return children;
};
